module.exports = __webpack_public_path__ + "img/5-kings.6a15dd60.jpg";